<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:24:01
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div class='main-container box'>
                <div class='couponBox'>
                    <h5 v-show='isOk'>
                        <img :src="diconImg" alt="" class='dImg'>
                        <span>{{template.couponSimpleName?template.couponSimpleName:template.couponName}}</span>
                    </h5>
                    <p class='price' v-show="isOk && String(template.couponType) === '5'">
                        <span>{{template.faceAmount || 0}}</span>
                        折
                    </p>
                    <p class='price' v-show="isOk && String(template.couponType) !== '5'">
                        ￥<span>{{template.faceAmount}}</span>
                    </p>

                    <div class='time' v-show='isOk'>
                        <p class='timeTitle'>满{{template.thresholdAmount}}使用</p>
                        <p class='timeContent' v-if="template.couponValidityType !== '1'">有效时间 {{template.couponValidityStart}} - {{template.couponValidityEnd}}</p>
                        <p class='timeContent' v-if="template.couponValidityType === '1'">有效时间 领取后{{template.couponValidityDay}}天</p>
                    </div>
                </div>
                <div class='ljBox'>
                    <van-button round @click='couponOk(template)' type="danger" class='ljBtn' :disabled='template.couponTemplateProgress !== "进行中" || template.status !== "1"'>立即领券</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    components: {
        Toast
    },
    data() {
        return {
            couponImg: require('../assets/img/incoupon/couponBg.png'),
            diconImg: require('../assets/img/incoupon/dicon.png'),
            template: {},
            isOk: false
        };
    },
    esvReady() {
        const ths = this;
        ths.queryCouponTemplate();
    },
    esvShow() {},
    methods: {
        // 查询优惠券状态
        queryCouponTemplate() {
            const ths = this;
            const params = {
                couponTemplateCode: ths.getPramVal('couponTemplateCode'),
                token: ths.getPramVal('token')
            };
            ths.$doRequest(
                {
                    url: '/coupon/queryCouponTemplate',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.template = data.result;
                    ths.isOk = true;
                }
            );
        },
        getPramVal(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const str =
                window.location.href.indexOf('?') === -1
                    ? ''
                    : window.location.href.slice(
                        window.location.href.indexOf('?'),
                        window.location.href.length
                    );
            const r = str.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        // 点击领取优惠券
        couponOk() {
            const ths = this;
            const params = {
                couponTemplateCode: ths.getPramVal('couponTemplateCode')
            };
            ths.$doRequest(
                {
                    url: '/coupon/receiveCouponByActivity',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    Toast.success('领取成功');
                    setTimeout(function() {
                        ths.esvOpenPage('OPHomenew');
                    }, 1500);
                },
                function(data) {
                    Toast.fail(data.message);
                }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.box{
     padding: 20px;
}
.couponBox {
    background: url('../assets/img/incoupon/couponBg.png') no-repeat center center;
    background-size:100% 100%;
    height:190px;
    h5{
        padding:10px;
        line-height: 30px;
        span{
            color:white;
            padding:5px 10px;
            font-size:16px;
        }
    }
    .price {
        text-align: right;
        color: #fff;
        font-size: 14px;
        padding:0 10px;
        span {
            font-size: 30px;
        }
    }
    .time {
        padding:10px;
        color: #fff;
        .timeTitle{
            font-size: 14px;
        }
        .timeContent{
            color:#f3f3f3;
        }
    }
}
.dImg {
    width: 30px;
    height:30px;
    float: left;
}
.ljBox {
    text-align: center;
    margin-top:20px;
    .ljbtn {
        width: 80%;
        background: #ee2e50;
    }
}
</style>
